import { useParams } from 'react-router-dom';
import { getActiveUnsubscribeCampaign } from '../../config/campaigns';
import NotFoundPage from '../shared/NotFoundPage';
import UnsubscribeForm from './UnsubscribeForm';

export default function UnsubscribePage() {
  const { slug = '' } = useParams<{ slug: string }>();
  const config = getActiveUnsubscribeCampaign(slug);

  if (!config) {
    return <NotFoundPage />;
  }

  return (
    <div className="main-container">
      {config.topImage && <img src={config.topImage} className="skoda-top-img background-image full-height cover" alt="" />}
      <UnsubscribeForm config={config} />
    </div>
  );
}
